import { Component, OnInit, NgModule, ViewChild, TemplateRef, Input, Output, EventEmitter, forwardRef, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { UISelectBoxModule } from '../select-box/select-box.component';
import { Subject } from 'rxjs';
import { API } from '../services/api';
import { NgZorroAntdModule } from 'ng-zorro-antd';

export interface Department {
    compayId: string;
    compayName: string; 
    departments?:any;
    disabled?: boolean;
}
export interface DomOpt {
    code: string;
    fullName:string;
    id: string;
    name: string;
    remark: string;
}

export const /** @type {?} */ CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DepartmentSelectComponent),
    multi: true
};
export class DepartmentSelectComponent implements ControlValueAccessor,OnInit {
     domOpt: DomOpt;
private onTouchedCallback: () => () => {};
private onChangeCallback: (_: any) => () => {};

    options: Array<Department> = [];
    // 单选的时候传字符串，多选传数组
    _value: string;
    _width = "100%";
    _allowClear = true;
    _nzMode = "combobox";
    // 下拉过滤含关键字选项，false为不过滤
    _filter = false;
    currentText = '';
    canQuery = true;
    keyWordStream = new Subject<string>()
    keyWord$: any;
    _contentCompany: TemplateRef<any>;
    _contentDepartment: TemplateRef<any>;

     placeholder = "请输入网点";
    // 需要获取的值类型
     valueType = "object";
/**
 * @param {?} v
 * @return {?}
 */
set value(v: any) {
        if (typeof v === 'string' && v.trim() === '' || !v)
            this.queryData('', []);
        this._value = v;
        // 双向绑定获取对象
        if (this.valueType === "object") {
            this.onChangeCallback(v);
        } else {
            let /** @type {?} */ compayName = v.name || v;
            let /** @type {?} */ compayId = v.id || v;
            this.valueType === "id" ? this.onChangeCallback(compayId) : this.onChangeCallback(compayName);
        }
    }
/**
 * @return {?}
 */
get value(): any {
        return this._value;
    };
/**
 * @param {?} v
 * @return {?}
 */
set width(v: any) {
        const /** @type {?} */ width = parseInt(v);
        this._width = ( /** @type {?} */((<any>Array.from(v)))).includes("%") ? `${v}%` : isNaN(width) ? this._width : `${width}px`;
    }
/**
 * @param {?} tpl
 * @return {?}
 */
set customCompanyTemplate(tpl: TemplateRef<any>) {
        if (tpl instanceof TemplateRef) {
            this._contentCompany = tpl;
        }
    }
/**
 * @param {?} tpl
 * @return {?}
 */
set customDepartmentTemplate(tpl: TemplateRef<any>) {
        if (tpl instanceof TemplateRef) {
            this._contentDepartment = tpl;
        }
    }

     openChange: EventEmitter<any> = new EventEmitter();
     outOptions: EventEmitter<any> = new EventEmitter();
/**
 * @param {?} api
 */
constructor(private api: API) {
    }
/**
 * @return {?}
 */
ngOnInit() {
        // 限流
        this.keyWord$ = this.keyWordStream
            .debounceTime(250)
            .subscribe(word => {
                this.queryData(word, [])
            });

    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.keyWord$.unsubscribe()
    }
/**
 * @param {?} event
 * @return {?}
 */
yztSearchChange(event) {
        this.canQuery = true;
        this.currentText = event;
        this.keyWordStream.next(event);
    }
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any) {
        if (value !== this._value) {
            this._value = value;
        }
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }
/**
 * 查询数据
 * @param {?=} searchText
 * @param {?=} options
 * @return {?}
 */
queryData(searchText?: string, options?: Array<Department>) {
        if (!this.canQuery) return;
        let /** @type {?} */ qryParams = {
            name: searchText
        };
        let /** @type {?} */ page = {
            first: 0,
            rows: 9999
        };
        
        this.api.call("CommonController.findCompanyDepartment",page, qryParams).ok(json => {
            const /** @type {?} */ result = json.result || [];
            const /** @type {?} */ dataList = result.content || [];
            this.options = [];
            for (let /** @type {?} */ company of dataList) {

                if (!company.compayName) {
                    continue;
                }

                let /** @type {?} */ obj = {
                    "compayId": company.compayId,
                    "compayName": company.compayName,
                    "departments": company.departments
                };
                this.options.push(obj);
            }
            this.outOptions.emit(this.options);
            if (!this.options.length) {
                const /** @type {?} */ lastItem = new Array<Department>({ compayId: "empty", compayName: "没有更多选项！", disabled: true });
                this.options = options.concat(lastItem);
                this.canQuery = false;
                return;
            }
        }).fail(err => {
            if (!this.options.length) {
                const /** @type {?} */ lastItem = new Array<Department>({ compayId: "empty", compayName: "没有更多选项！", disabled: true });
                this.options = options.concat(lastItem);
                this.canQuery = false;
                return;
            }
            throw new Error(err);
        });
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'yzt-department',
  template: `
    <div class="department-select">
    <nz-select 
        class="department-nz-select"
        [style.width]="_width" 
        [nzPlaceHolder]="placeholder"
        [nzMode]="_nzMode"
        [nzFilter]="_filter"
        [nzAllowClear]="_allowClear"
        (nzSearchChange)="yztSearchChange($event)"
        [(ngModel)]="value">
        <nz-option #domOpt *ngFor="let option of options;let i=$index" [nzLabel]="option.compayName" [nzDisabled]='true' nzValue='_parent_{{i}}'>
            <ng-template *ngIf="_contentCompany" #nzOptionTemplate>
                <ng-container [ngTemplateOutlet]="_contentCompany" [ngTemplateOutletContext]="option"></ng-container>
            </ng-template>
            <nz-option *ngFor="let obj of option.departments" [nzLabel]="obj.name" [nzValue]="obj">
                <ng-template *ngIf="_contentDepartment" #nzOptionTemplate>
                    <ng-container [ngTemplateOutlet]="_contentDepartment" [ngTemplateOutletContext]="obj"></ng-container>
                </ng-template>
            </nz-option>
        </nz-option>
    </nz-select>
    </div>`,
  styles: [`
    .department-select{
        position: relative;
    }
    .close-icon {
        opacity: 0;
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -10px;
    }
    .close-icon:hover {
        opacity: 1;
    }
    .department-nz-select:hover +.close-icon {
        opacity: 1;
    }
  `],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: API, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'domOpt': [{ type: ViewChild, args: ["domOpt", ] },],
'placeholder': [{ type: Input },],
'valueType': [{ type: Input },],
'width': [{ type: Input },],
'customCompanyTemplate': [{ type: Input },],
'customDepartmentTemplate': [{ type: Input },],
'openChange': [{ type: Output },],
'outOptions': [{ type: Output },],
};
}

function DepartmentSelectComponent_tsickle_Closure_declarations() {
/** @type {?} */
DepartmentSelectComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DepartmentSelectComponent.ctorParameters;
/** @type {?} */
DepartmentSelectComponent.propDecorators;
/** @type {?} */
DepartmentSelectComponent.prototype.domOpt;
/** @type {?} */
DepartmentSelectComponent.prototype.onTouchedCallback;
/** @type {?} */
DepartmentSelectComponent.prototype.onChangeCallback;
/** @type {?} */
DepartmentSelectComponent.prototype.options;
/** @type {?} */
DepartmentSelectComponent.prototype._value;
/** @type {?} */
DepartmentSelectComponent.prototype._width;
/** @type {?} */
DepartmentSelectComponent.prototype._allowClear;
/** @type {?} */
DepartmentSelectComponent.prototype._nzMode;
/** @type {?} */
DepartmentSelectComponent.prototype._filter;
/** @type {?} */
DepartmentSelectComponent.prototype.currentText;
/** @type {?} */
DepartmentSelectComponent.prototype.canQuery;
/** @type {?} */
DepartmentSelectComponent.prototype.keyWordStream;
/** @type {?} */
DepartmentSelectComponent.prototype.keyWord$;
/** @type {?} */
DepartmentSelectComponent.prototype._contentCompany;
/** @type {?} */
DepartmentSelectComponent.prototype._contentDepartment;
/** @type {?} */
DepartmentSelectComponent.prototype.placeholder;
/** @type {?} */
DepartmentSelectComponent.prototype.valueType;
/** @type {?} */
DepartmentSelectComponent.prototype.openChange;
/** @type {?} */
DepartmentSelectComponent.prototype.outOptions;
/** @type {?} */
DepartmentSelectComponent.prototype.api;
}

export class DepartmentSelectModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations: [
        DepartmentSelectComponent
    ],
    exports: [DepartmentSelectComponent],
    imports: [
        CommonModule,
        FormsModule,
        NgZorroAntdModule
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DepartmentSelectModule_tsickle_Closure_declarations() {
/** @type {?} */
DepartmentSelectModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DepartmentSelectModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
